import styled from '@emotion/styled';
import Select from 'components/Inputs/Select';
import { ModalBody, ModalFooter } from '..';
import Switch from 'components/Kizen/Switch';
import css from '@emotion/css';

export const StyledSelect = styled(Select)`
  margin-bottom: 15px;
`;

export const StyledModalBody = styled(ModalBody)`
  > :last-child {
    margin-bottom: 0;
  }
`;

export const StyledModalFooter = styled(ModalFooter)`
  & button:last-of-type {
    margin-left: 0;
  }
`;

export const CustomizeFieldOptionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 10px;

  i {
    margin-left: 5px;
  }
`;

export const RequiredSwitch = styled(Switch)`
  ${({ enableBottomMargin = false }) =>
    enableBottomMargin &&
    css`
      margin-bottom: 15px;
    `}
`;
